import { React, TextField, Typography } from '../../utils/globalImports';

interface CustomTextFieldProps {
    label?: string;
    name: string;
    value?: string | number;
    disable?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
    sx?: object; // Allow custom styling
    type?: string; // Optional prop for input type (e.g., "email" for email field)
    required?: boolean;
    isTextArea?: boolean;
    inputProps?: object; //  Allow min/max or other input props
    InputProps?: object;
    inputRef?: React.Ref<any>; // Accept inputRef from Autocomplete
    hideLabel?: boolean; // Option to hide the label if not needed
    tempPlaceHolder?:string
}

const CustomTextField: React.FC<CustomTextFieldProps> = ({
    label,
    name,
    value,
    disable,
    onChange,
    onFocus,   // ⬅ ADD THIS LINE
    sx,
    type = 'text', // Default to text input type, can be overridden
    required = false, // Default to false, can be set to true for required fields
    isTextArea = false,
    inputProps = {}, //  Default to empty object
    InputProps = {},
    inputRef,
    hideLabel = false,
    tempPlaceHolder // Default to false, can be set to true to hide the label
}) => {
    return (
        <div>
            {/* Label */}
            {!hideLabel && 
                <Typography variant="subtitle1" sx={{ display: 'block', color: '#1e66ab', fontSize: 14, fontWeight: 500, ml: 1 }}>
                    {label}
                    {required && <span style={{ color: 'red' }}>*</span>}  {/* Conditionally add a red asterisk */}
                </Typography>
            }

            {/* TextField with capsule shape (rounded corners and extra padding) */}
            <TextField
                variant="outlined" // explicitly set variant
                name={name}
                placeholder={tempPlaceHolder || label}
                value={value}
                onChange={onChange}
                onFocus={onFocus}   // ⬅ ADD THIS LINE
                fullWidth
                type={type}
                disabled={disable}
                multiline={isTextArea} // Enable multiline if `isTextArea` is true
                rows={isTextArea ? 4 : 1}
                // minRows={isTextArea ? 2 : 1}
                // maxRows={isTextArea ? 6 : 1} // Set rows to 4 for TextArea and 1 for single-line input
                inputProps={{
                    ...(type === 'number' ? { min: 0 } : {}),
                    ...inputProps, // Merge in any passed inputProps (e.g. min: 1, max: 100)
                }}
                InputProps={InputProps} //  Required for Autocomplete
                inputRef={inputRef}     //  Required for Autocomplete
                sx={{
                    borderRadius: isTextArea ? '10px' : '50px',  // Fully rounded corners for capsule shape
                    height: isTextArea ? 'auto' : '35px', // Auto height for TextArea
                    '& .MuiOutlinedInput-root': {
                        borderRadius: isTextArea ? '10px' : '50px', // Ensure the input also has rounded corners
                        height: '100%',        // Ensure input maintains height
                    },
                    '& .MuiInputBase-input': {
                        paddingLeft: isTextArea ? '' : '15px',    // Adjust padding for vertical alignment of text
                        fontSize: '14px'
                    },
                    '& .MuiOutlinedInput-input:-webkit-autofill': {
                        height: 0,
                        WebkitBoxShadow: '0 0 0 1000px white inset !important',
                    },
                    ...sx,
                }}
            />
        </div>
    );
};

export default CustomTextField;
